/* ==========================================================================
   NP Collective — Gallery behavior (shared by all gallery groups + nav)
   Loaded once via <script src="{{ 'gallery.js' | asset_url }}" defer></script>
   Uses event delegation, so it covers any number of gallery sections.
   ========================================================================== */
(function () {
  if (window.__npgInit) return;      // guard: run once even if referenced by many sections
  window.__npgInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ---- Lightbox singleton ---- */
    var lb = document.createElement('div');
    lb.className = 'npg-lb';
    lb.innerHTML =
      '<button class="npg-lb-btn npg-lb-close" aria-label="Close">&times;</button>' +
      '<button class="npg-lb-btn npg-lb-prev" aria-label="Previous">&#8249;</button>' +
      '<img alt="">' +
      '<button class="npg-lb-btn npg-lb-next" aria-label="Next">&#8250;</button>' +
      '<div class="npg-lb-count"></div>';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');
    var lbCount = lb.querySelector('.npg-lb-count');
    var set = [], idx = 0;

    function show(i) {
      if (!set.length) return;
      idx = (i + set.length) % set.length;
      var img = set[idx].querySelector('img');
      if (!img) return;
      lbImg.src = img.getAttribute('data-full') || img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
      lbCount.textContent = (idx + 1) + ' / ' + set.length;
    }
    function openFrom(item) {
      var grid = item.closest('.npg-grid');
      if (!grid) return;
      set = Array.prototype.slice.call(grid.querySelectorAll('.npg-item'))
        .filter(function (it) { return !it.classList.contains('is-hidden') && it.querySelector('img'); });
      var start = set.indexOf(item);
      if (start < 0) return;
      show(start);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeLb() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }

    lb.querySelector('.npg-lb-close').addEventListener('click', closeLb);
    lb.querySelector('.npg-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    lb.querySelector('.npg-lb-next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });

    /* ---- Delegated clicks: filters, items, load-more ---- */
    document.addEventListener('click', function (e) {
      var filter = e.target.closest('.npg-filter');
      if (filter) {
        var group = filter.closest('.npg-group');
        if (!group) return;
        group.querySelectorAll('.npg-filter').forEach(function (b) {
          b.classList.toggle('is-active', b === filter);
        });
        var val = filter.getAttribute('data-filter');
        group.querySelectorAll('.npg-item').forEach(function (it) {
          var match = (val === 'all') || (it.getAttribute('data-cat') === val);
          it.classList.toggle('is-filtered-out', !match);
        });
        applyVisibility(group);
        return;
      }

      var more = e.target.closest('.npg-more');
      if (more) {
        var g = more.closest('.npg-group');
        if (g) { g.dataset.expanded = '1'; applyVisibility(g); more.remove(); }
        return;
      }

      var item = e.target.closest('.npg-item');
      if (item && item.querySelector('img')) { e.preventDefault(); openFrom(item); return; }
    });

    /* ---- Visibility = filter state + optional "load more" cap ---- */
    function applyVisibility(group) {
      var cap = parseInt(group.getAttribute('data-initial') || '0', 10);
      var expanded = group.dataset.expanded === '1' || !cap;
      var shown = 0;
      group.querySelectorAll('.npg-item').forEach(function (it) {
        var filteredOut = it.classList.contains('is-filtered-out');
        var hide = filteredOut;
        if (!hide && !expanded) { hide = shown >= cap; }
        if (!filteredOut) shown++;
        it.classList.toggle('is-hidden', hide);
      });
    }
    // initialise each group's cap on load
    document.querySelectorAll('.npg-group').forEach(function (g) { applyVisibility(g); });

    /* ---- Back-to-top ---- */
    var top = document.createElement('button');
    top.className = 'npg-top'; top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = '&#8593;';
    document.body.appendChild(top);
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', function () {
      top.classList.toggle('is-shown', window.scrollY > 600);
    }, { passive: true });

    /* ---- Sticky nav: highlight the section in view ---- */
    var navLinks = document.querySelectorAll('.npg-nav a');
    if (navLinks.length && 'IntersectionObserver' in window) {
      var byId = {};
      navLinks.forEach(function (a) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        if (id) byId[id] = a;
      });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && byId[en.target.id]) {
            navLinks.forEach(function (a) { a.classList.remove('is-current'); });
            byId[en.target.id].classList.add('is-current');
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      document.querySelectorAll('.npg-group[id]').forEach(function (g) { obs.observe(g); });
    }
  });
})();